import type { FC } from "react";

import { PresentationBanner } from "./PresentationBanner";

import { useHomeRole } from "components/materials/home/use-home-role";
import { FollowButton } from "components/materials/presentation/FollowButton";
import { t } from "i18n/i18n";
import { useAppSelector } from "store/index";
import { selectCoursesForCurrentUser } from "store/selectors";

export const HomePresentationBanner: FC = () => {
  const { currentRole } = useHomeRole();
  const coursesForRole = useAppSelector((s) => selectCoursesForCurrentUser(s, currentRole));
  const courseCodeMap = useAppSelector((s) => s.course_codes);
  const color = "green";

  const presentingCourses = coursesForRole.filter((course) => course.presented_page_id);
  if (
    presentingCourses.length === 0 ||
    !currentRole ||
    !["student", "instructor"].includes(currentRole)
  ) {
    return null;
  }

  if (presentingCourses.length === 1) {
    const course = presentingCourses[0];
    const courseCode = courseCodeMap[course.course_code_id];

    return (
      <PresentationBanner
        bannerText={`${courseCode?.title}: ${t("presentation.presentation_in_progress")}`}
        color={color}
      >
        <FollowButton color={color} courseId={course.id} />
      </PresentationBanner>
    );
  }

  return <PresentationBanner bannerText={t("presentation.multiple_courses")} color={color} />;
};
